import React from 'react';

const PrivacyPage: React.FC = () => {
    return (
        <div>
            <header className="App-header">
                <h1>Cragknollian Privacy Policy</h1>

                <p>This page refers to WarScholar by Cogpocket <a
                    href="https://play.google.com/store/apps/details?id=com.cogpocket.warscholar"
                    target="_blank"
                    rel="noopener noreferrer">
                    on Google Play store
                </a>.</p>






                <p>This privacy policy will help you understand how we use and protects</p>
                <p>the data you provide to us when you visit and use our services.</p>
                <p>We reserve the right to change this policy at any given time, of </p>
                <p>which you will be promptly updated. If you want to make sure that you</p>
                <p>are up to date with the latest changes, we advise you to frequently visit this page.</p>

                <p>What User Data We Collect:</p>
                <p>- Nothing.</p>

                <p>Why We Dont Collect Your Data</p>
                <p>- Its your data, you're welcome to it.</p>
                <p>- We don't currently have any capacity or use for any data whatsoever.</p>

                <p> We will not lease, sell or distribute your personal information to any third</p>
                <p>parties, becuase we don't have it to start with. </p>
                <p>Have a nice day! 😎</p>



            </header>

        </div>
    );
};

export default PrivacyPage;
